'use client';

import { LazyMotion } from 'motion/react';
import { FC, PropsWithChildren } from 'react';

export const LazyMotionWrapperFull: FC<PropsWithChildren> = ({ children }) => (
  <LazyMotion features={async () => (await import('./fullFramerMotionFeatures')).default} strict>
    {children}
  </LazyMotion>
);
